import { type Institution, getInstitutionByDomain } from '../../services';
import {
  createSlice,
  createAsyncThunk,
  type PayloadAction,
} from '@reduxjs/toolkit';
import { getInstitutionSubdomain } from '../../hooks/institutions/useInstitutionSubdomain';
import { type AppDispatch, type RootState } from '../../stores/redux/setup';

type InstitutionSliceState = {
  institution?: Institution | null;
};

const initialState: InstitutionSliceState = {
  institution: undefined,
};

export const institutionSlice = createSlice({
  name: 'institution',

  initialState,

  reducers: {
    initialize: (
      state,
      action: PayloadAction<{
        institution: Institution | null;
      }>,
    ) => {
      return {
        ...state,
        institution: action.payload.institution,
      };
    },
  },
});

export const { initialize } = institutionSlice.actions;

export const getInstitutionAsync = createAsyncThunk<
  Institution | null,
  undefined,
  { state: RootState; dispatch: AppDispatch }
>('institution/getInstitution', async (_payload, { dispatch }) => {
  const institutionDomain = getInstitutionSubdomain(window.location.host);

  if (institutionDomain === null) {
    return null;
  }

  return dispatch(
    getInstitutionByDomain.initiate({
      institutionDomain,
    }),
  ).unwrap();
});
